import { api } from "../http";
import type { DeclarationMeta } from "../types";
import { readConfigEntry, saveConfigEntry } from "../../offline/db";
import { isRuntimeOfflineEnabled } from "../../offline/runtime";
import { isNavigatorOffline } from "../../offline/referenceCache";
import { getOfflineCachePolicy } from "../../offline/cachePolicy";

const DECLARATION_META_CACHE_KEY = "meta/declaration";

const shouldUseCachedMeta = () => isNavigatorOffline() || isRuntimeOfflineEnabled();

export const metaApi = {
  async declaration(): Promise<DeclarationMeta> {
    if (shouldUseCachedMeta()) {
      const cached = await readConfigEntry<DeclarationMeta>(DECLARATION_META_CACHE_KEY);
      if (cached?.data) {
        return cached.data;
      }
    }

    try {
      const data = await api.get<DeclarationMeta>("/api/meta/declaration");
      const ttlMs = getOfflineCachePolicy().metaTtlMs;
      await saveConfigEntry({
        type: DECLARATION_META_CACHE_KEY,
        data,
        updatedAt: Date.now(),
        expiresAt: ttlMs ? Date.now() + ttlMs : null,
      });
      return data;
    } catch (error) {
      const cached = await readConfigEntry<DeclarationMeta>(DECLARATION_META_CACHE_KEY);
      if (cached?.data) {
        return cached.data;
      }
      throw error;
    }
  },
};
